//Formato de fecha para cuando los datos regresan de la db
export const formateoFechas = (fecha) => {
  const date = new Date(fecha);
  // Obtener los componentes de la fecha
  const day = date.getDate();
  const month = date.toLocaleString("es-ES", { month: "long" });
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Formatear la fecha
  return `${day} de ${month} de ${year} ${hours}:${minutes}`;
};

export const normalizarFecha = (f) => {
  if (f && typeof f.toDate === "function")
    return formateoFechas(f.toDate());

  if (typeof f === "string" || f instanceof Date)
    return formateoFechas(f);

  return null;
}

export const getCurrentDateTime = () => {
  const current = new Date();
  const year = current.getFullYear();
  const month = String(current.getMonth() + 1).padStart(2, "0"); // Mes comienza en 0
  const day = String(current.getDate()).padStart(2, "0");
  const hours = String(current.getHours()).padStart(2, "0");
  const minutes = String(current.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
